module.exports = __webpack_public_path__ + "img/ISA-Hero-Banner.b653fc57.png";